// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordStrength_wrapper__x+xsJ","bar":"PasswordStrength_bar__33AKw","barProgress":"PasswordStrength_barProgress__H0ncI","text":"PasswordStrength_text__dsuY+"};